import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface NotificationFerme { id: number; titre: string; corps: string; ecran?: string; sujet?: string; date: string; lu: boolean; }
export interface PageNotifications { elements: NotificationFerme[]; nonLues: number; total: number; }

/** Boîte de notifications de la ferme (même source que le mobile) */
@Injectable({ providedIn: 'root' })
export class NotificationsService {

  private readonly base = `${environment.BASE_URL}/api/notifications`;

  constructor(private http: HttpClient) {}

  liste(page = 0, taille = 20): Observable<PageNotifications> {
    return this.http.get<PageNotifications>(this.base, { params: new HttpParams().set('page', page).set('taille', taille) });
  }

  nonLues(): Observable<{ nonLues: number }> { return this.http.get<{ nonLues: number }>(`${this.base}/non-lues`); }

  lue(id: number): Observable<{ nonLues: number }> { return this.http.post<{ nonLues: number }>(`${this.base}/${id}/lu`, {}); }

  toutLu(): Observable<{ nonLues: number }> { return this.http.post<{ nonLues: number }>(`${this.base}/tout-lu`, {}); }
}
